import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IrbAppEvents } from '@irb/app.events';
import { AppService } from '@irb/app.service';
import { UtilityService } from '@irb/irb-common/services/utility.service';
import { ISystemMessage } from '@irb/irb-dashboard/irb-dashboard.model';
import { IrbDialogsEvents } from '@irb/irb-dialogs/irb-dialogs.events';
import {IAlertDialogData} from '@irb/app.model';

export interface DialogAnnoucementEditConfig {
  systemMessage: ISystemMessage;
  onProceed: Function;
}

@Component({ standalone: false,
  selector: 'irb-dialog-announcement-edit',
  templateUrl: './dialog-announcement-edit.component.html',
  styleUrls: ['./dialog-announcement-edit.component.scss']
})
export class DialogAnnouncementEditComponent implements OnInit {
  action: string;
  data: ISystemMessage;
  originalData: ISystemMessage;
  minDate: Date;
  expirationDate: Date;
  isModified: boolean = false;
  isValid: boolean = false;
  modulesConfig: any;

  constructor(
    public dialogRef: MatDialogRef<DialogAnnouncementEditComponent>, 
    @Inject(MAT_DIALOG_DATA) public mdd: DialogAnnoucementEditConfig, 
    private as: AppService,
    private util: UtilityService) {
      const today = new Date();
      this.minDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);

      if(this.mdd.systemMessage) {
        this.action = "Update";
        this.data = this.util.clone(this.mdd.systemMessage);

        if(this.data.expirationDate) {
          this.expirationDate = new Date(this.data.expirationDate);
        }        
      } else {
        this.action = "Create";
        this.data = {
          messageTitle: "",
          messageText: null,
          isActive: false,
          expirationDate: null,
          modifiedDate: (new Date()).getTime(),
          tempId: this.util.generateUUID()
        };
      }

      this.originalData = this.util.clone(this.data);

      this.modulesConfig = {
        clipboard: { matchVisual: false }
      };
  }

  ngOnInit(): void {
  }

  continue() {
    if(this.mdd.onProceed) {
      this.mdd.onProceed(this.data);
    }

    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }

  preview() {
    this.as.fireEvent(IrbDialogsEvents.SHOW_ANNOUNCEMENTS, {
      systemMessage: this.data
    });
  }

  onInputChange() {
    setTimeout(() => {
      if(this.expirationDate) {
        this.data.expirationDate = this.expirationDate.setHours(0, 0, 0);
      } else {
        this.data.expirationDate = null;
      }

      this.isModified = !this.util.compare(this.originalData, this.data, ["isModified"]);
      this.data.isModified = this.isModified;
      this.isValid = this.validateInput();
    });
  }

  validateInput() {
    const hasMessageTitle = this.data.messageTitle !== null && this.data.messageTitle.length > 0;
    const hasMessageText = this.data.messageText !== null && this.data.messageText.length > 0;
    const expirationDateIsValid = this.validateExpirationDate();
    return hasMessageTitle && hasMessageText && (!this.data.isActive || (this.data.isActive && expirationDateIsValid));
  }

  validateExpirationDate() {
    return this.data.expirationDate === null || this.data.expirationDate >= this.minDate.getTime();
  }

  warnOnInvalidExpirationDate() {
    const expirationDateIsValid = this.validateExpirationDate();

    if(this.data.isActive && !expirationDateIsValid) {
      this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
        msg: "An active announcement can not have an expiration date in the past.",
        dProceedBtnLabel: "Ok",
        dType: "WARN"
      } as IAlertDialogData);
    }
  }
}
